export default {
  filter: '',
  productDetailsClosed: false,
  productSectionsClosed: [],
};
